import React, { useEffect, useState } from 'react';

import { isDevelopment } from '@common/utils/debug';

export default function HMRProgress() {
  const [progress, setProgress] = useState(null);
  const handleMessage = ({ data }) => {
    const parsedData = JSON.parse(data);
    const { type, data: { percent } = {} } = parsedData;
    if (type === 'invalid') {
      setProgress(20);
      return;
    }
    /* istanbul ignore else */
    if (type === 'progress-update') {
      if (percent === 100) {
        setProgress(null);
      } else {
        setProgress(percent);
      }
    }
  };

  useEffect(() => {
    if (!isDevelopment()) return;

    const webSocket = new WebSocket('ws://localhost:8080/sockjs-node');
    webSocket.onmessage = handleMessage;
  }, []);
  if (isDevelopment() && progress > 0) {
    return (
      <>
        {progress && (
          <div
            className="hmr"
          >
            <div className="hmr__progress" style={{ width: `${progress}%` }} />
          </div>
        )}
      </>
    );
  } else {
    return null;
  }
}
